/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

export enum TimeScale {
	Day = 'day',
	Week = 'week',
	Quarter = 'quarter',
}
